import { useSelector } from 'react-redux';
import { Org } from 'new/entities/Org';
import { useMemo } from 'react';

type Options = {
  onlyMine?: boolean;
};

export function useOrgs(options: Options = {}) {
  const { onlyMine } = options;
  const orgsObj = useSelector((state: any) => state.entities.orgs);
  const orgs = Object.values(orgsObj) as Org[];
  return useMemo(
    () =>
      onlyMine
        ? orgs.filter((org) => org?.access_roles?.length > 0 && org.status === 'ACTIVE')
        : orgs,
    [orgsObj],
  );
}
